import ConfirmPassword from './ConfirmPassword';

export default ConfirmPassword;
